module.exports = __webpack_public_path__ + "src/img/cookies/cover-logo.77d64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/cover-logo.jpg
// module id = 103
// module chunks = 0